
import { API_BASE_URL } from '../globals';
import {
  QC_MASTER_SAMPLE_CSV_DOWNLOAD,
  QC_MASTER_DOWNLOAD_DUMP,
  QC_MASTER_DELETE,
  QC_MASTER_UPDATE,
  QC_MASTER_UPLOAD,
  QC_MASTER_FETCH,
  PACKAGING_MASTER_SAMPLE_CSV_DOWNLOAD,
  PACKAGING_MASTER_DOWNLOAD_DUMP,
  PACKAGING_MASTER_DELETE,
  PACKAGING_MASTER_UPDATE,
  PACKAGING_MASTER_UPLOAD,
  PACKAGING_MASTER_FETCH,
} from './routes';

import { GET, POST } from './apiHandler';

export const downloadSampleCsvQcMaster = async () => {
  return GET(
    `${API_BASE_URL}${QC_MASTER_SAMPLE_CSV_DOWNLOAD}`,
    'blob',
  );
};

export const downloadSampleCsvPackagingMaster = async () => {
  return GET(
    `${API_BASE_URL}${PACKAGING_MASTER_SAMPLE_CSV_DOWNLOAD}`,
    'blob',
  );
};

export const downloadQcMastersData = async () => {
  return GET(
    `${API_BASE_URL}${QC_MASTER_DOWNLOAD_DUMP}`,
    {},
    'blob',
  );
};

export const downloadPackagingMastersData = async () => {
  return GET(
    `${API_BASE_URL}${PACKAGING_MASTER_DOWNLOAD_DUMP}`,
    {},
    'blob',
  );
};

export const deleteQcMasters = async (body) => {
  return POST(
    `${API_BASE_URL}${QC_MASTER_DELETE}`,
    body,
  );
}

export const deletePackagingMasters = async (body) => {
  return POST(
    `${API_BASE_URL}${PACKAGING_MASTER_DELETE}`,
    body,
  );
}

export const updateQcMasters = async (body) => {
  return POST(
    `${API_BASE_URL}${QC_MASTER_UPDATE}`,
    body
  );
};

export const updatePackagingMasters = async (body) => {
  return POST(
    `${API_BASE_URL}${PACKAGING_MASTER_UPDATE}`,
    body
  );
};

export const uploadQcMasters = async (body) => {
  return POST(
    `${API_BASE_URL}${QC_MASTER_UPLOAD}`,
    body,
  );
};

export const uploadPackagingMasters = async (body) => {
  return POST(
    `${API_BASE_URL}${PACKAGING_MASTER_UPLOAD}`,
    body,
  );
};

export const fetchQcMasters = async () => {
  return GET(
    `${API_BASE_URL}${QC_MASTER_FETCH}`
  );
};

export const fetchPackagingMasters = async () => {
  return GET(
    `${API_BASE_URL}${PACKAGING_MASTER_FETCH}`
  );
};
